import React from 'react';
import { UseFixedAssetsStatusGrid } from './hooks/useFixedAssetsStatusGrid';
import BaseFormGrid from '../../components/grids/BaseFormGrid';
import { cloneDeep } from 'lodash';
import { AssetStatusesGridDefs } from '../../constants/i18n/translations/termDefinitions/accounting';
import TranslatableText from '../../components/i18n/TranslatableText';
import { isNilOrEmpty } from '../../utils/objectUtils';

const FixedAssetStatusGrid = () => {
    const {
        statusList,
        isLoading,
        canCreateAssetStatus,
        canViewAssetStatus,
        canUpdate,
        redirectToForm,
        handleGridEdits,
        rowData,
        colDefs,
        termSet,
    } = UseFixedAssetsStatusGrid();

    return (
        <BaseFormGrid
            title={
                <TranslatableText
                    termSet={termSet}
                    termKey={AssetStatusesGridDefs.Asset_Statuses}
                />
            }
            displayGrid={canViewAssetStatus}
            isLoading={isNilOrEmpty(colDefs)}
            rowData={cloneDeep(rowData)}
            useRowDrag={canUpdate}
            sortKey={'sortOrder'}
            columnDefs={colDefs}
            gridClass="full-size-item"
            displayToolbar={true}
            displayCreateNewButton={canCreateAssetStatus}
            displayResetStateButton={true}
            onCreateNew={redirectToForm}
            displayExportDataButton={true}
            onRowClicked={({ data }) => redirectToForm(data)}
            onHandleGridEdits={handleGridEdits}
        />
    );
};

export default FixedAssetStatusGrid;
